import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginSharedService } from './login/login-shared.service';
import { LoginService } from './login/login.service';
import { NotificationService } from './shared/generic-notification/notification.service';

@Injectable()
export class PreLoginAuthGuard  {

    constructor(private readonly notificationService: NotificationService,
        private readonly loginShared: LoginSharedService,
        private readonly loginService: LoginService,
        private readonly router: Router) { }

    async canActivate(): Promise<boolean> {
        this.notificationService.loadingEvent.next({ showLoading: true, loadingMessage: 'Loading App..!' });
        if (this.loginShared.isLoggedIn()) {
            await this.router.navigate(['home']);
            this.notificationService.loadingEvent.next({ showLoading: false });
            return false;
        }
        const loginURL = await this.loginService.saveRequest();
        window.open(loginURL, '_self', 'noopener,noreferrer');
        return false;
    }
}